var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_container",attrs:{"id":"mam_funds"}},[_c('funds-spot-ex',{ref:"balancesComponent",attrs:{"isSinglePage":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }